"use client"

import { CustomBreadcrumbs } from "@eurodrive/ui"
import Container from "@eurodrive/ui/Container"

export default function Breadcrumbs({ carName }: { carName: string }) {
  return (
    <Container paddingMobile>
      <CustomBreadcrumbs
        noPadding
        breadcrumbs={{
          selfObject: { title: carName, url: "" },
          parents: [{ title: "ראשי", url: "/" }],
        }}
      />
    </Container>
  )
}
